<div class="error-wrapper">
    <div>
        <img src="../../../../assets/images/page-refused-error.svg" alt="page-refused" class="h100">
    </div>
    <div>
        <span>Refused to connect.</span>
    </div>
</div>